import { IAppState } from '../../redux';
import { ETopBetsStatus } from '../../redux/reducers';

export function selectTopBetsStatus(state: IAppState): ETopBetsStatus {
  const {
    topBets: { status },
  } = state;

  return status;
}
